import PQNormsDataDownload from './PQNormsDataDownload';
export default PQNormsDataDownload;